
// 定义中文语言包对象
export default {
    navigateBar: {
        hotspot: '热点',
        experience: '经验',
        focus: '关注',
        recommend: '推荐',

        records: '记录',
        Home: '首页',
        New: '新游',
        Hot: "热门",
        Rank: "排行",
        calegories: '热门类目',
        about: '相关',
        about_us: '关于我们',
        contact_us: '联系我们',
        feedback: '意见反馈',
        fqa: '常见问题',
        user_privacy: "隐私政策",
        sbervice_Terms: "服务条款",
        business_cooperation: '商务合作',
        developers: "开发者平台",
        new_games: '全新推荐',
        hot_games: '热门推荐',
        rank_games: '排行榜单',
        view_more: '更多内容',
        friends: "我的好友",
        favorites: "我的收藏",
        user_center: "用户信息",



        FriendsTotal: "好友总数",
        FavoritesTotal: "收藏总数",
        GamePlayedTotal: "游玩总数",
        GameLikedTotal: "喜欢总数",

        mob_FriendsTotal: "好友总数",
        mob_FavoritesTotal: "收藏总数",
        mob_GamePlayedTotal: "游玩总数",
        mob_GameLikedTotal: "喜欢总数",



        Recently_Played: '最近玩过',
        Favorites: "我的收藏",
        My_wallet: "我的钱包",
        LogOut: "退出登录",
        Del_Accout: "注销账号",
        Confirm: "确认",
        Cancel: "取消",
        twdya: "此操作将会注销您的账号",
        newuser: "新用户点此，",
        Register: "注册",
        Forget_Password: "忘记密码",
        Login: '登录',
        tpal: "第三方授权登录",
        Hasaccount: "已拥有账号 , ",
        iam13: "我已年满 13 周岁（或适用的最低年龄），且了解并接受<a class='atext' href='/terms_of_service.html' target='_blank' rel='noopener noreferrer'>《服务条款》</a>和<a class='atext' href='/privacy_policy.html' target='_blank' rel='noopener noreferrer'>《隐私政策》</a>",
        Reset_Password: "重置密码",
        Bring_your_friends: "带上你的朋友！",
        Create_a_CrazyGames: "创建你的账号",
        start_inviting_your_friends: "开始邀请您的朋友",
        Invitte_your_friends: "邀请您的朋友",
        FindFriendsbySearchiingForTheirUsemames: "通过搜索来寻找朋友,",
        or: "或者",
        ShareyourQrcodeinviteLink: "或者 分享您的 二维码/邀请链接"
    },
    List: "列表",
    Received: "收到请求",
    Sent: '发送请求',
    Mine: "我的二维码",
    showqr: '将此二维码展示给您的朋友，以便他们扫描',
    // 并向您发送好友请求
    sendyoufdre: "并向您发送好友请求",
    Shareyourprofile: "分享您的个人资料",
    CopyInviteLink: "复制你的分享链接",
    Massage: "信息内容",
    Your_emall: "您的 邮箱（可选）",
    FeebackType: "反馈类型",
    Phoneoptional: "您的 电话（可选）",
    Submit: "提交",
    feebackgame: "反馈游戏",
    Playnow: "开始游戏",
    GameDescription: "游戏介绍",
    Rating: "评分",
    Developer: "开发者",
    Released: "发布时间",
    LastUpdated: "最后更新时间",
    Technology: "开发工具",
    Platforms: '登录平台',
    Classification: "游戏类型",
    Tags: '游戏标签',
    Dontrecommend: '不再推荐',
    Sharegame: '分享游戏',
    Ratinggame: "评分",

    All: "全部",
    Annoucement: "系统公告",
    Private: '私信消息',
    Activity: '活动消息',
    Unread: '未读',
    Read: "已读",
    BatchSetRead: '批量读取',
    Manage: "管理",
    Delete: "删除",
    passwordage: '至少一个小写字母、至少一个大写字母、至少一个数字和至少一个特殊字符，密码长度必须至少为 8 个字符',
    plpassword: "请输入密码",
    plemail: '请输入邮箱',
    emailformat: '请输入正确的邮箱格式',
    emailsending: '验证码发送中，请稍候...',
    emailsuccess: '验证码发送成功，请查收邮箱',
    emailfailed: '验证码发送失败，请重试',
    emailwait: '请等待 {time} 秒后再次发送',
    networkerror: '网络错误，请稍后重试',

    plemailcode: "请输入邮箱验证码",
    plSelectfd: "请选择选择类型",
    UserAgreement: "请同意用户协议",
    plfbmes: '请输入反馈信息',
    plphone: "请输入您的电话",
    phoneformat: '请输入正确的电话格式',
    pladdemail: "请输入您的邮箱地址",
    plselefg: "请选择收藏游戏",
    // Received Request
    ReceivedRequest: "收到请求",
    // Sent Request
    SentRequest: "发送请求",
    Searchgame: "搜索游戏",
    Searchbygame: "通过游戏名称搜索游戏",
    plgnsg: "请输入游戏名称搜索游戏",
    FindFrieds: "通过名字搜索好友",
    Searchms: "通过消息名称搜索",
    PlIyophone: "请输入电话号码",
    useinfochage: "修改信息",
    usecomplete: "完成",
    Notyet: "暂无",
    pllogin: '请先登录',
    Controls: "操作说明",
    Sharethegame: '分享游戏',
    Send: "发送",
    Loginsuccessful: "登录成功",
    // /Login failed
    Loginfailed: "登录失败",
    Alltoal: "总页数",
    peuea: "请输入你的邮箱",
    statrtime: "开始时间",
    endtime: "结束时间",
    timetogo: "到",
    Screenshotproblem: "问题截图",
    Quickmaps: "快捷截图",
    Screenshot: "请上传问题图片 或者 问题截图",
    Gamedetail: "游戏详情",
    copygamelink: "复制",
    tabs: {
        work: '作品',
        private: '私密',
        collect: '收藏',
        like: '喜欢'
    },
    Undercpst:'正在建设中，敬请期待！',
    Continueplaying: "继续游玩",
    NoUsersFound: "未找到匹配的用户",
    Sharefriends: '分享好友',
    cookieBanner: {
        title: "Cookie使用通知",
        description: "我们使用Cookie和类似技术来改善网站运行，提供个性化体验，并根据您的浏览活动和兴趣投放广告。继续使用即表示您同意我们使用Cookie。",
        learnMore: "了解更多",
        accept: "接受全部",
        reject: "拒绝非必要",
    }
}